import React from 'react';
import { connect } from 'react-redux';

import { onNew } from '../../reducers/listeners/project';

class ProjectCustom extends React.Component {

    constructor(props) {
        super(props);
    }

    handleClick = () => {
        onNew();
    }

    render() {
        const { intlr } = this.props;
        return (
            <div className="item" onClick={this.handleClick}>
                <div className="item-content-container user-create">
                    <div className="project-content">
                        <div className="item-icon"><i className="mblock-icon icon-xinjianxiangmu"></i></div>
                        <span>{intlr.messages['MENU.FILE.NEW']}</span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(ProjectCustom);
